import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

const headingProps = {
  bold: Boolean,
  color: String,
};

export type HeadingProps = {
  bold: boolean;
  color: keyof typeof theme.colors;
};

export const Wrapper = styled('div', headingProps)`
  ${({ bold, color }: HeadingProps) => css`
    & {
      color: ${theme.colors[color]};
      ${bold && `font-weight: ${theme.font.bold}`}
    }
  `}
`;
